export const CS_KEYS = {
  LANGUAGE: 'bobe_language',
  CURRENT_DAY: 'bobe_current_day',
  APP_CURRENT_VERSION: 'bobe_app_current_version',
  BOOSTERS: {
    TURBO_BOOST: 'bobe_game_boosters_turbo_boost',
  },
};
